import gql from "graphql-tag";

export const queryGetImportData = gql`
    query ent ($auth:AuthInput){
        getImportData(input:$auth)
        {
            importdata{
                 id
                 name
                 importType
                 isArchived
            }
        }
    }
`;
